import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SectionsService {

	private sections: Array<any> = [
		{
			position: 0,
			routeName: 'Exploration',
			name: 'Never Stop Exploring',
			shortname: 'Exploration',
			subtitle: "Highlights of a half  century at space."
		},
		{
			position: 1,
			routeName: 'NewYorkCity',
			name: 'The Beginning',
			shortname: 'New York City',
			subtitle: "Highlights of a half  century at city."
		},
		{
			position: 2,
			routeName: 'PopCulture',
			name: 'Pop Culture',
			shortname: 'Pop Culture',
			subtitle: "Highlights of a half  century at sea."
		},
		{
			position: 3,
			routeName: 'Innovation',
			name: 'Always on the cutting edge',
			shortname: 'Innovation',
			subtitle: "Highlights of a half  century at sky."
		}
	]; 
	private currentPosition: number = this.sections[0].position; 
	private currentSectionContent; 

	@Output() changeSection: EventEmitter<number> = new EventEmitter();
	@Output() changeSectionContent: EventEmitter<number> = new EventEmitter();

	public getSections(): Array<any> {
		return this.sections;
	}
	public getCurrentSectionPosition(): number {
		return this.currentPosition;
	}
	public setCurrentPosition(value: number) {
		this.currentPosition = value;
		this.changeSection.emit(this.currentPosition);
	}

	//get the content of the section
	public getCurrentSectionContent() {
		return this.currentSectionContent;
	}
	public setCurrentSectionContent(value) {
		this.currentSectionContent = value;
		this.changeSectionContent.emit(this.currentSectionContent);
	}

}
